export var MoneyUnit;
(function (MoneyUnit) {
    MoneyUnit["UNIT"] = "unit";
    MoneyUnit["CENTS"] = "cents";
})(MoneyUnit || (MoneyUnit = {}));
